import * as HEATMAPS from './heatmaps';

// creating path variants without the trailing param as
// react router v6 no longer supports optional params.
const createPathWithoutParam = HEATMAPS.CREATE.path.slice().replace(':copyId', '');
const editPathWithoutParam = HEATMAPS.EDIT.path.slice().replace(':heatmapId', '');
const reportPathWithoutParam = HEATMAPS.REPORT.path.slice().replace(':heatmapId', '');

export const MH_PATHS = [
  HEATMAPS.LIST.path,
  HEATMAPS.LIST_SNAPSHOTS.path,
  HEATMAPS.CREATE.path,
  createPathWithoutParam,
  HEATMAPS.EDIT.path,
  editPathWithoutParam,
  HEATMAPS.REPORT.path,
  reportPathWithoutParam,
] as const;
